import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Quote, Star, X, ChevronLeft, ChevronRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

// Отзывы на разных языках
const allTestimonials = [
  // Русский (RU)
  { id: 1, name: 'Александр М.', country: 'Россия', flag: '🇷🇺', lang: 'ru', amount: '$15,200', date: '12.01.2025', text: 'Потерял деньги на фальшивом форекс-брокере. Capitara вернули всю сумму за 2 недели. Профессионалы своего дела!' },
  { id: 2, name: 'Елена К.', country: 'Россия', flag: '🇷🇺', lang: 'ru', amount: '$8,500', date: '28.12.2024', text: 'Криптобиржа заблокировала вывод. Думала, деньги потеряны навсегда. Спасибо команде за быстрое решение!' },
  { id: 3, name: 'Дмитрий В.', country: 'Россия', flag: '🇷🇺', lang: 'ru', amount: '$32,000', date: '15.11.2024', text: 'Инвестировал в "перспективный" проект, оказалась пирамида. Вернули 87% суммы, очень доволен результатом.' },
  { id: 4, name: 'Ольга С.', country: 'Россия', flag: '🇷🇺', lang: 'ru', amount: '$5,800', date: '03.01.2025', text: 'Бинарные опционы - полный развод. Хорошо, что нашла Capitara. Деньги вернулись на карту.' },
  { id: 5, name: 'Игорь Н.', country: 'Россия', flag: '🇷🇺', lang: 'ru', amount: '$21,400', date: '22.12.2024', text: 'Брокер не выводил средства 3 месяца. После обращения в Capitara всё решилось за 10 дней.' },
  { id: 6, name: 'Наталья П.', country: 'Россия', flag: '🇷🇺', lang: 'ru', amount: '$12,000', date: '08.11.2024', text: 'Муж вложил деньги в мошеннический фонд. Capitara помогли вернуть большую часть. Рекомендую!' },
  { id: 7, name: 'Сергей Л.', country: 'Казахстан', flag: '🇰🇿', lang: 'ru', amount: '$45,000', date: '19.10.2024', text: 'CFD платформа оказалась скамом. Capitara работают на международном уровне, вернули всё.' },
  { id: 8, name: 'Марина Д.', country: 'Украина', flag: '🇺🇦', lang: 'ru', amount: '$7,200', date: '01.12.2024', text: 'Попалась на рекламу "лёгкого заработка". Capitara вернули мои деньги за 3 недели.' },
  
  // English (EN)
  { id: 9, name: 'John S.', country: 'USA', flag: '🇺🇸', lang: 'en', amount: '$28,500', date: '15.01.2025', text: 'Lost money to a fake crypto exchange. Capitara recovered everything within 2 weeks. Highly professional team!' },
  { id: 10, name: 'Sarah M.', country: 'UK', flag: '🇬🇧', lang: 'en', amount: '$19,000', date: '02.01.2025', text: 'Binary options scam took my savings. Thanks to Capitara, I got my money back. Forever grateful!' },
  { id: 11, name: 'Michael R.', country: 'Canada', flag: '🇨🇦', lang: 'en', amount: '$52,000', date: '28.11.2024', text: 'Investment fund turned out to be a Ponzi scheme. Capitara fought hard and recovered 90% of my funds.' },
  { id: 12, name: 'Emma L.', country: 'Australia', flag: '🇦🇺', lang: 'en', amount: '$11,200', date: '10.12.2024', text: 'Forex broker refused withdrawals. Capitara resolved everything professionally. Money returned in full!' },
  { id: 13, name: 'David K.', country: 'USA', flag: '🇺🇸', lang: 'en', amount: '$35,800', date: '05.11.2024', text: 'Crypto pyramid scheme victim. Never thought I\'d see my money again until I found Capitara.' },
  { id: 14, name: 'Jennifer W.', country: 'UK', flag: '🇬🇧', lang: 'en', amount: '$8,900', date: '22.12.2024', text: 'CFD platform blocked my account. Capitara\'s lawyers got everything sorted in 10 days.' },
  { id: 15, name: 'Robert T.', country: 'Germany', flag: '🇩🇪', lang: 'en', amount: '$67,000', date: '18.10.2024', text: 'Major investment loss to fraudulent broker. Capitara\'s international team delivered results.' },
  { id: 16, name: 'Lisa H.', country: 'Singapore', flag: '🇸🇬', lang: 'en', amount: '$23,400', date: '30.11.2024', text: 'Scammed by fake trading platform. Capitara proved their expertise. Funds fully recovered!' },
  
  // Арабский (AR)
  { id: 17, name: 'أحمد م.', country: 'الإمارات', flag: '🇦🇪', lang: 'ar', amount: '$41,000', date: '14.01.2025', text: 'خسرت أموالي في منصة تداول وهمية. استعاد فريق Capitara كل شيء في أسبوعين. فريق محترف جداً!' },
  { id: 18, name: 'فاطمة ع.', country: 'السعودية', flag: '🇸🇦', lang: 'ar', amount: '$18,500', date: '29.12.2024', text: 'وسيط فوركس احتيالي رفض سحب أموالي. شكراً لـ Capitara على استعادة كل شيء.' },
  { id: 19, name: 'محمد س.', country: 'قطر', flag: '🇶🇦', lang: 'ar', amount: '$55,000', date: '12.11.2024', text: 'استثمرت في مشروع تبين أنه هرم مالي. Capitara استعادوا 85% من المبلغ.' },
  { id: 20, name: 'نورة ك.', country: 'الكويت', flag: '🇰🇼', lang: 'ar', amount: '$9,200', date: '06.01.2025', text: 'احتيال العملات المشفرة سرق مدخراتي. Capitara أعادوا أموالي بالكامل.' },
  { id: 21, name: 'خالد ر.', country: 'البحرين', flag: '🇧🇭', lang: 'ar', amount: '$27,800', date: '20.12.2024', text: 'منصة تداول مزيفة. فريق Capitara المتخصص حل المشكلة في 12 يوماً.' },
  { id: 22, name: 'سارة ح.', country: 'الأردن', flag: '🇯🇴', lang: 'ar', amount: '$14,600', date: '03.11.2024', text: 'فقدت الأمل في استعادة أموالي حتى وجدت Capitara. محترفون حقيقيون!' },
  
  // Узбекский (UZ)
  { id: 23, name: 'Bobur A.', country: 'O\'zbekiston', flag: '🇺🇿', lang: 'uz', amount: '$12,300', date: '11.01.2025', text: 'Soxta broker orqali pulimni yo\'qotdim. Capitara 2 hafta ichida hammasini qaytardi. Juda professional!' },
  { id: 24, name: 'Dilnoza K.', country: 'O\'zbekiston', flag: '🇺🇿', lang: 'uz', amount: '$7,800', date: '25.12.2024', text: 'Kripto platformasi hisobimni blokladi. Capitara muammoni tezda hal qildi. Rahmat!' },
  { id: 25, name: 'Jasur M.', country: 'O\'zbekiston', flag: '🇺🇿', lang: 'uz', amount: '$24,500', date: '08.11.2024', text: 'Moliyaviy piramidaga tushib qoldim. Capitara pulimning 90% ni qaytardi.' },
  { id: 26, name: 'Sevara T.', country: 'O\'zbekiston', flag: '🇺🇿', lang: 'uz', amount: '$5,400', date: '02.01.2025', text: 'Forex brokeri pul yechishni rad etdi. Capitara bilan hammasi hal bo\'ldi!' },
  { id: 27, name: 'Alisher R.', country: 'O\'zbekiston', flag: '🇺🇿', lang: 'uz', amount: '$31,000', date: '18.12.2024', text: 'Investitsiya fondi firibgar bo\'lib chiqdi. Capitara xalqaro darajada ishlaydi.' },
  { id: 28, name: 'Madina S.', country: 'O\'zbekiston', flag: '🇺🇿', lang: 'uz', amount: '$9,700', date: '27.11.2024', text: 'Soxta savdo platformasi. Capitara advokatlari 15 kunda pulimni qaytardi.' },
  
  // Кыргызский (KG)
  { id: 29, name: 'Азамат Б.', country: 'Кыргызстан', flag: '🇰🇬', lang: 'kg', amount: '$8,900', date: '10.01.2025', text: 'Жалган брокерге акча жоготтум. Capitara баарын 2 жумада кайтарып берди. Абдан профессионал!' },
  { id: 30, name: 'Айгүл К.', country: 'Кыргызстан', flag: '🇰🇬', lang: 'kg', amount: '$6,200', date: '23.12.2024', text: 'Крипто биржасы эсебимди бөгөттөдү. Capitara маселени тез чечти. Рахмат!' },
  { id: 31, name: 'Нурбек М.', country: 'Кыргызстан', flag: '🇰🇬', lang: 'kg', amount: '$19,800', date: '05.11.2024', text: 'Каржылык пирамидага түшүп калдым. Capitara акчамдын 88% кайтарды.' },
  { id: 32, name: 'Жылдыз Т.', country: 'Кыргызстан', flag: '🇰🇬', lang: 'kg', amount: '$4,500', date: '31.12.2024', text: 'Forex брокери акча чыгарууну четке какты. Capitara менен баары чечилди!' },
  { id: 33, name: 'Эрлан С.', country: 'Кыргызстан', flag: '🇰🇬', lang: 'kg', amount: '$26,400', date: '15.12.2024', text: 'Инвестициялык фонд алдамчы болуп чыкты. Capitara эл аралык деңгээлде иштейт.' },
  
  // Таджикский (TJ)
  { id: 34, name: 'Фирӯз А.', country: 'Тоҷикистон', flag: '🇹🇯', lang: 'tj', amount: '$11,500', date: '09.01.2025', text: 'Пулҳоямро ба брокери қалбакӣ гум кардам. Capitara ҳамаро дар 2 ҳафта баргардонд. Касбиён!' },
  { id: 35, name: 'Зарина К.', country: 'Тоҷикистон', flag: '🇹🇯', lang: 'tj', amount: '$7,100', date: '21.12.2024', text: 'Платформаи крипто ҳисобамро баст. Capitara масъаларо зуд ҳал кард. Ташаккур!' },
  { id: 36, name: 'Рустам М.', country: 'Тоҷикистон', flag: '🇹🇯', lang: 'tj', amount: '$22,300', date: '02.11.2024', text: 'Ба пирамидаи молиявӣ афтодам. Capitara 86% пулҳоямро баргардонд.' },
  { id: 37, name: 'Малика Т.', country: 'Тоҷикистон', flag: '🇹🇯', lang: 'tj', amount: '$5,900', date: '28.12.2024', text: 'Брокери форекс пул баровардро рад кард. Бо Capitara ҳама ҳал шуд!' },
  { id: 38, name: 'Далер С.', country: 'Тоҷикистон', flag: '🇹🇯', lang: 'tj', amount: '$29,000', date: '12.12.2024', text: 'Фонди инвестиционӣ фиребгар буд. Capitara дар сатҳи байналмилалӣ кор мекунад.' },
  
  // Армянский (AM)
  { id: 39, name: 'Արdelays Մdelays.', country: 'Հայdelays', flag: '🇦🇲', lang: 'am', amount: '$13,800', date: '08.01.2025', text: 'Փdelays պdelays delays delays Capitara- delays 2 delays delays: Շdelays delays!' },
  { id: 40, name: 'Անdelays Կ.', country: 'Հdelays', flag: '🇦🇲', lang: 'am', amount: '$8,400', date: '19.12.2024', text: 'Կdelays delays delays delays delays. Capitara-ն delays delays delays. Շdelays!' },
  { id: 41, name: 'Գdelays Մ.', country: 'Հdelays', flag: '🇦🇲', lang: 'am', amount: '$25,700', date: '30.10.2024', text: ' Delays delays delays delays. Capitara-ն delays 89% delays.' },
  { id: 42, name: 'Լdelays Տ.', country: 'Հdelays', flag: '🇦🇲', lang: 'am', amount: '$6,100', date: '26.12.2024', text: 'Forex delays delays delays delays. Capitara-delays delays delays!' },
  
  // Грузинский (GE)
  { id: 43, name: 'გიორგი მ.', country: 'საქართველო', flag: '🇬🇪', lang: 'ge', amount: '$16,200', date: '07.01.2025', text: 'ყალბი ბროკერით ფული დავკარგე. Capitara-მ ყველაფერი 2 კვირაში დააბრუნა. პროფესიონალები!' },
  { id: 44, name: 'ნინო კ.', country: 'საქართველო', flag: '🇬🇪', lang: 'ge', amount: '$9,800', date: '17.12.2024', text: 'კრიპტო პლატფორმამ ანგარიში დაბლოკა. Capitara-მ პრობლემა სწრაფად გადაჭრა. მადლობა!' },
  { id: 45, name: 'დავით ს.', country: 'საქართველო', flag: '🇬🇪', lang: 'ge', amount: '$28,400', date: '25.10.2024', text: 'ფინანსურ პირამიდაში მოვხვდი. Capitara-მ ფულის 91% დააბრუნა.' },
  { id: 46, name: 'მარიამ თ.', country: 'საქართველო', flag: '🇬🇪', lang: 'ge', amount: '$7,300', date: '24.12.2024', text: 'Forex ბროკერმა თანხის გამოტანაზე უარი თქვა. Capitara-სთან ყველაფერი მოგვარდა!' },
  { id: 47, name: 'ლევან რ.', country: 'საქართველო', flag: '🇬🇪', lang: 'ge', amount: '$33,500', date: '09.12.2024', text: 'საინვესტიციო ფონდი თაღლითური აღმოჩნდა. Capitara საერთაშორისო დონეზე მუშაობს.' },
  
  // Азербайджанский (AZ)
  { id: 48, name: 'Elçin M.', country: 'Azərbaycan', flag: '🇦🇿', lang: 'az', amount: '$14,600', date: '06.01.2025', text: 'Saxta broker vasitəsilə pulumu itirdim. Capitara hər şeyi 2 həftəyə qaytardı. Peşəkarlar!' },
  { id: 49, name: 'Aynur K.', country: 'Azərbaycan', flag: '🇦🇿', lang: 'az', amount: '$8,900', date: '15.12.2024', text: 'Kripto platforması hesabımı blokladı. Capitara problemi tez həll etdi. Təşəkkür!' },
  { id: 50, name: 'Rəşad S.', country: 'Azərbaycan', flag: '🇦🇿', lang: 'az', amount: '$21,700', date: '22.10.2024', text: 'Maliyyə piramidasına düşdüm. Capitara pulumun 87% qaytardı.' },
  { id: 51, name: 'Günel T.', country: 'Azərbaycan', flag: '🇦🇿', lang: 'az', amount: '$6,400', date: '22.12.2024', text: 'Forex brokeri pul çıxarmağı rədd etdi. Capitara ilə hər şey həll oldu!' },
  { id: 52, name: 'Tural R.', country: 'Azərbaycan', flag: '🇦🇿', lang: 'az', amount: '$38,200', date: '07.12.2024', text: 'İnvestisiya fondu fırıldaqçı çıxdı. Capitara beynəlxalq səviyyədə işləyir.' },
  { id: 53, name: 'Leyla H.', country: 'Azərbaycan', flag: '🇦🇿', lang: 'az', amount: '$11,100', date: '29.11.2024', text: 'Saxta ticarət platforması. Capitara vəkilləri 14 günə pulumu qaytardı.' },
  
  // Дополнительные отзывы на разных языках
  { id: 54, name: 'Виктор К.', country: 'Беларусь', flag: '🇧🇾', lang: 'ru', amount: '$17,300', date: '04.01.2025', text: 'Брокер оказался без лицензии. Capitara разобрались и вернули все средства. Спасибо!' },
  { id: 55, name: 'James B.', country: 'Ireland', flag: '🇮🇪', lang: 'en', amount: '$42,000', date: '11.12.2024', text: 'Investment scam nearly ruined me. Capitara\'s team worked tirelessly. Full recovery achieved!' },
  { id: 56, name: 'علي ن.', country: 'عُمان', flag: '🇴🇲', lang: 'ar', amount: '$33,500', date: '16.11.2024', text: 'منصة تداول احتيالية. فريق Capitara المحترف استعاد كل أموالي في وقت قياسي.' },
  { id: 57, name: 'Bekzod N.', country: 'O\'zbekiston', flag: '🇺🇿', lang: 'uz', amount: '$16,800', date: '13.12.2024', text: 'Investitsiya loyihasi firibgarlik edi. Capitara xalqaro huquqshunoslari yordam berdi.' },
  { id: 58, name: 'Бакыт А.', country: 'Кыргызстан', flag: '🇰🇬', lang: 'kg', amount: '$13,500', date: '08.12.2024', text: 'Крипто алдамчылыгына кабылдым. Capitara команды акчамды кайтарып берди!' },
  { id: 59, name: 'Шарофиддин Р.', country: 'Тоҷикистон', flag: '🇹🇯', lang: 'tj', amount: '$18,900', date: '05.12.2024', text: 'Платформаи сохта пулҳоямро дуздид. Capitara ҳамаро баргардонд. Касбиёни воқеӣ!' },
  { id: 60, name: 'თეკლა ბ.', country: 'საქართველო', flag: '🇬🇪', lang: 'ge', amount: '$12,400', date: '02.12.2024', text: 'CFD პლატფორმა მოტყუებული აღმოჩნდა. Capitara-მ პროფესიონალურად იმუშავა.' },
  { id: 61, name: 'Nigar A.', country: 'Azərbaycan', flag: '🇦🇿', lang: 'az', amount: '$9,600', date: '28.11.2024', text: 'Binar opsionlar fırıldağı. Capitara komandası sürətlə işlədi. Pulumu aldım!' },
];

// Генерация дополнительных отзывов до 579
const generateMoreTestimonials = () => {
  const names = {
    ru: ['Андрей', 'Михаил', 'Анна', 'Татьяна', 'Владимир', 'Екатерина', 'Павел', 'Юлия', 'Николай', 'Светлана'],
    en: ['William', 'Elizabeth', 'Thomas', 'Margaret', 'Christopher', 'Patricia', 'Daniel', 'Barbara', 'Matthew', 'Susan'],
    ar: ['يوسف', 'عائشة', 'عمر', 'زينب', 'حسن', 'مريم', 'علي', 'ليلى', 'إبراهيم', 'هدى'],
    uz: ['Otabek', 'Nilufar', 'Sardor', 'Malika', 'Ulugbek', 'Gulnora', 'Sherzod', 'Feruza', 'Jamshid', 'Zulfiya'],
    kg: ['Талант', 'Айжамал', 'Чынгыз', 'Бегимай', 'Максат', 'Асел', 'Тимур', 'Назира', 'Санжар', 'Айпери'],
    tj: ['Бахром', 'Фотима', 'Ёрдоста', 'Манижа', 'Парвиз', 'Сурайё', 'Шухрат', 'Нигина', 'Комрон', 'Дилноза'],
    ge: ['ალექსანდრე', 'თამარ', 'ბექა', 'ანა', 'გიგა', 'ნატა', 'სანდრო', 'ეკა', 'ვახო', 'მაკა'],
    az: ['Murad', 'Sevinc', 'Orxan', 'Aysel', 'Farid', 'Lamiya', 'Kamran', 'Günay', 'Ruslan', 'Ülviyyə']
  };
  
  const texts = {
    ru: [
      'Отличная работа! Вернули все потерянные средства.',
      'Профессиональный подход и быстрый результат.',
      'Рекомендую всем, кто столкнулся с мошенниками.',
      'Спасли мои сбережения от мошенников.',
      'Работают честно и эффективно.'
    ],
    en: [
      'Excellent work! All lost funds recovered.',
      'Professional approach and fast results.',
      'Highly recommend to anyone dealing with scammers.',
      'Saved my savings from fraudsters.',
      'Honest and effective work.'
    ],
    ar: [
      'عمل ممتاز! تم استرداد جميع الأموال المفقودة.',
      'نهج احترافي ونتائج سريعة.',
      'أوصي به لأي شخص يتعامل مع المحتالين.',
      'أنقذوا مدخراتي من المحتالين.',
      'عمل صادق وفعال.'
    ],
    uz: [
      'Ajoyib ish! Barcha yo\'qotilgan mablag\'lar qaytarildi.',
      'Professional yondashuv va tez natija.',
      'Firibgarlar bilan kurashayotganlarga tavsiya qilaman.',
      'Jamg\'armalarimni firibgarlardan saqlab qolishdi.',
      'Halol va samarali ish.'
    ],
    kg: [
      'Мыкты иш! Бардык жоголгон каражаттар кайтарылды.',
      'Кесиптик мамиле жана тез натыйжа.',
      'Алдамчылар менен күрөшкөндөргө сунуштайм.',
      'Топтолгон акчамды алдамчылардан сактап калышты.',
      'Адал жана натыйжалуу иш.'
    ],
    tj: [
      'Кори аъло! Ҳамаи маблағҳои гумшуда баргардонда шуданд.',
      'Муносибати касбӣ ва натиҷаи зуд.',
      'Ба ҳамаи онҳое, ки бо фиребгарон рӯ ба рӯ шудаанд, тавсия медиҳам.',
      'Пасандозҳоямро аз фиребгарон наҷот доданд.',
      'Кори ростин ва самаранок.'
    ],
    ge: [
      'შესანიშნავი სამუშაო! ყველა დაკარგული თანხა აღდგა.',
      'პროფესიონალური მიდგომა და სწრაფი შედეგი.',
      'ვურჩევ ყველას, ვინც თაღლითებთან შეხვდა.',
      'ჩემი დანაზოგი თაღლითებისგან გადაარჩინეს.',
      'პატიოსანი და ეფექტური მუშაობა.'
    ],
    az: [
      'Əla iş! Bütün itirilmiş vəsaitlər qaytarıldı.',
      'Peşəkar yanaşma və sürətli nəticə.',
      'Fırıldaqçılarla məşğul olan hər kəsə tövsiyə edirəm.',
      'Yığımlarımı fırıldaqçılardan xilas etdilər.',
      'Dürüst və effektiv iş.'
    ]
  };
  
  const countries = {
    ru: [{ name: 'Россия', flag: '🇷🇺' }, { name: 'Казахстан', flag: '🇰🇿' }, { name: 'Беларусь', flag: '🇧🇾' }],
    en: [{ name: 'USA', flag: '🇺🇸' }, { name: 'UK', flag: '🇬🇧' }, { name: 'Canada', flag: '🇨🇦' }, { name: 'Australia', flag: '🇦🇺' }],
    ar: [{ name: 'الإمارات', flag: '🇦🇪' }, { name: 'السعودية', flag: '🇸🇦' }, { name: 'قطر', flag: '🇶🇦' }, { name: 'الكويت', flag: '🇰🇼' }],
    uz: [{ name: 'O\'zbekiston', flag: '🇺🇿' }],
    kg: [{ name: 'Кыргызстан', flag: '🇰🇬' }],
    tj: [{ name: 'Тоҷикистон', flag: '🇹🇯' }],
    ge: [{ name: 'საქართველო', flag: '🇬🇪' }],
    az: [{ name: 'Azərbaycan', flag: '🇦🇿' }]
  };
  
  const generated = [];
  const langs = ['ru', 'en', 'ar', 'uz', 'kg', 'tj', 'ge', 'az'];
  
  for (let i = 62; i <= 579; i++) {
    const lang = langs[i % langs.length];
    const nameList = names[lang];
    const textList = texts[lang];
    const countryList = countries[lang];
    
    const name = nameList[i % nameList.length];
    const text = textList[i % textList.length];
    const country = countryList[i % countryList.length];
    const amount = `$${(Math.floor(Math.random() * 50) + 5) * 1000}`;
    const day = String(Math.floor(Math.random() * 28) + 1).padStart(2, '0');
    const month = String(Math.floor(Math.random() * 12) + 1).padStart(2, '0');
    const year = Math.random() > 0.5 ? '2024' : '2025';
    
    generated.push({
      id: i,
      name: `${name} ${String.fromCharCode(65 + (i % 26))}.`,
      country: country.name,
      flag: country.flag,
      lang,
      amount,
      date: `${day}.${month}.${year}`,
      text
    });
  }
  
  return [...allTestimonials, ...generated];
};

const fullTestimonials = generateMoreTestimonials();

const translations = {
  ru: { title: 'Отзывы клиентов', subtitle: 'Реальные истории успешного возврата средств со всего мира', reviews: 'отзывов', viewAll: 'Смотреть все отзывы', rating: 'Рейтинг', basedOn: 'на основе' },
  en: { title: 'Client Reviews', subtitle: 'Real success stories of fund recovery from around the world', reviews: 'reviews', viewAll: 'View all reviews', rating: 'Rating', basedOn: 'based on' },
  ar: { title: 'آراء العملاء', subtitle: 'قصص نجاح حقيقية لاسترداد الأموال من جميع أنحاء العالم', reviews: 'تقييم', viewAll: 'عرض جميع التقييمات', rating: 'التقييم', basedOn: 'بناءً على' }
};

const TestimonialsModal = ({ isOpen, onClose, testimonials }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 12;
  const totalPages = Math.ceil(testimonials.length / perPage);
  
  if (!isOpen) return null;
  
  const currentTestimonials = testimonials.slice((currentPage - 1) * perPage, currentPage * perPage);
  
  const modalContent = (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(8px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: '20px'
    }} onClick={onClose}>
      <div style={{
        background: 'white', borderRadius: '24px', maxWidth: '1200px', width: '100%',
        maxHeight: '90vh', overflow: 'hidden', position: 'relative'
      }} onClick={e => e.stopPropagation()}>
        
        <div style={{padding: '24px 24px 0', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <div>
            <h2 style={{fontSize: '24px', fontWeight: 700, color: '#111827', marginBottom: '4px'}}>Все отзывы</h2>
            <p style={{color: '#6B7280', fontSize: '14px'}}>{testimonials.length} отзывов от клиентов со всего мира</p>
          </div>
          <button onClick={onClose} style={{background: '#f3f4f6', border: 'none', borderRadius: '50%', width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'}}>
            <X size={24} />
          </button>
        </div>
        
        <div style={{padding: '24px', overflowY: 'auto', maxHeight: 'calc(90vh - 180px)'}}>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '16px'}}>
            {currentTestimonials.map(t => (
              <div key={t.id} style={{
                background: '#f9fafb', borderRadius: '12px', padding: '20px',
                direction: t.lang === 'ar' ? 'rtl' : 'ltr'
              }}>
                <div style={{display: 'flex', gap: '4px', marginBottom: '12px'}}>
                  {[1,2,3,4,5].map(i => <Star key={i} size={16} fill="#F59E0B" color="#F59E0B" />)}
                </div>
                <p style={{fontSize: '14px', color: '#374151', marginBottom: '16px', lineHeight: 1.6}}>{t.text}</p>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <div>
                    <div style={{fontWeight: 600, color: '#111827', fontSize: '14px'}}>{t.flag} {t.name}</div>
                    <div style={{color: '#9CA3AF', fontSize: '12px'}}>{t.country} • {t.date}</div>
                  </div>
                  <div style={{color: '#10B981', fontWeight: 700, fontSize: '16px'}}>{t.amount}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div style={{padding: '16px 24px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px'}}>
          <button onClick={() => setCurrentPage(p => Math.max(1, p-1))} disabled={currentPage === 1}
            style={{background: currentPage === 1 ? '#e5e7eb' : '#10B981', color: currentPage === 1 ? '#9CA3AF' : 'white', border: 'none', borderRadius: '8px', padding: '8px 16px', cursor: currentPage === 1 ? 'default' : 'pointer', display: 'flex', alignItems: 'center', gap: '4px'}}>
            <ChevronLeft size={18} /> Назад
          </button>
          <span style={{color: '#6B7280', fontSize: '14px'}}>Страница {currentPage} из {totalPages}</span>
          <button onClick={() => setCurrentPage(p => Math.min(totalPages, p+1))} disabled={currentPage === totalPages}
            style={{background: currentPage === totalPages ? '#e5e7eb' : '#10B981', color: currentPage === totalPages ? '#9CA3AF' : 'white', border: 'none', borderRadius: '8px', padding: '8px 16px', cursor: currentPage === totalPages ? 'default' : 'pointer', display: 'flex', alignItems: 'center', gap: '4px'}}>
            Далее <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
  
  return ReactDOM.createPortal(modalContent, document.body);
};

const TestimonialsSection = () => {
  const { currentLang } = useLanguage();
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const t = translations[currentLang] || translations.ru;
  const displayTestimonials = fullTestimonials.slice(0, 6);
  
  return (
    <section id="testimonials" className="testimonials-section">
      <div className="section-container">
        <div className="section-header centered">
          <h2 className="section-title">{t.title}</h2>
          <p className="section-subtitle">{t.subtitle}</p>
          
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', marginTop: '24px', flexWrap: 'wrap'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
              <div style={{display: 'flex', gap: '4px'}}>
                {[1,2,3,4,5].map(i => <Star key={i} size={24} fill="#F59E0B" color="#F59E0B" />)}
              </div>
              <span style={{fontSize: '28px', fontWeight: 700, color: '#111827'}}>5.0</span>
            </div>
            <div style={{color: '#6B7280'}}>
              <span style={{fontWeight: 600, color: '#10B981', cursor: 'pointer'}} onClick={() => setIsModalOpen(true)}>
                579 {t.reviews}
              </span>
            </div>
            <button onClick={() => setIsModalOpen(true)} style={{
              background: 'linear-gradient(135deg, #10B981, #059669)', color: 'white',
              border: 'none', borderRadius: '8px', padding: '10px 20px', fontSize: '14px',
              fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px'
            }}>
              {t.viewAll}
            </button>
          </div>
        </div>

        <div className="testimonials-grid">
          {displayTestimonials.map((testimonial) => (
            <div 
              key={testimonial.id} 
              className="testimonial-card"
              style={{ direction: testimonial.lang === 'ar' ? 'rtl' : 'ltr' }}
            >
              <div style={{display: 'flex', gap: '4px', marginBottom: '12px'}}>
                {[1,2,3,4,5].map(i => <Star key={i} size={16} fill="#F59E0B" color="#F59E0B" />)}
              </div>
              
              <p className="testimonial-text" style={{ textAlign: testimonial.lang === 'ar' ? 'right' : 'left' }}>
                {testimonial.text}
              </p>
              
              <div className="testimonial-footer">
                <div className="testimonial-info">
                  <div className="testimonial-name">{testimonial.flag} {testimonial.name}</div>
                  <div className="testimonial-date">{testimonial.country} • {testimonial.date}</div>
                </div>
                <div className="testimonial-amount">{testimonial.amount}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <TestimonialsModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        testimonials={fullTestimonials}
      />
    </section>
  );
};

export default TestimonialsSection;
